import { render, staticRenderFns } from "./PageControls.vue?vue&type=template&id=470691f6&"
import script from "./PageControls.vue?vue&type=script&lang=js&"
export * from "./PageControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports